export default __webpack_public_path__ + "static/media/epica-mobile.197d58ef.png";